module.exports = __webpack_public_path__ + "img/trust-feature-3.b4bd5c29.svg";